// Project data array
const projectsData = [
  {
    id: 1,
    title: "Totowala App",
    description: "Driver-first ride-booking platform (Toto, Bike, Cab, Auto) with separate rider and driver Android apps, real-time booking, GPS tracking, and zero-commission payouts. Serving 8,000+ users with 750+ rides completed.",
    tags: ["Java", "Firebase", "Node.js", "Express", "Google Cloud", "Supabase"],
    image: "/totowala.jpg",
    liveLink: "https://totowala.in/",
    codeLink: "https://play.google.com/store/apps/details?id=com.elt.totowala",
    featured: true
  },
  {
    id: 2,
    title: "Spendify - AI Expense Tracker",
    description: "Android app to track and manage personal expenses with AI-powered categorization and spending insights. Built with React Native and Expo, live on Google Play Store.",
    tags: ["React Native", "Expo", "Firebase", "AI API"],
    image: "/spendify.jpg",
    liveLink: "https://play.google.com/store/apps/details?id=com.theandroguy.ExpenseTracker&hl=en_US",
    featured: true,
    personal: true
  },
  {
    id: 3,
    title: "Trico - Ride Operations Admin Panel",
    description: "Internal admin panel for Totowala to manage drivers and users, oversee every ride, and handle day-to-day ride-hailing operations.",
    tags: ["Next.js", "Node.js", "Express", "PostgreSQL", "Supabase"],
    image: "/trico.jpg",
    featured: false
  },
  {
    id: 4,
    title: "Quantum CRM",
    description: "Internal CRM built for EasyLearningTre to manage and track leads across the organization.",
    tags: ["React", "Node.js", "Express", "Supabase", "Tailwind CSS", "shadcn/ui"],
    image: "/crm.jpg",
    featured: false
  },
  {
    id: 5,
    title: "Learning Management System (LMS)",
    description: "Internal LMS for onboarding and training, with structured course content and progress tracking.",
    tags: ["PHP", "JavaScript", "Tailwind CSS", "MySQL"],
    image: "/lms.jpg",
    featured: false
  },
  {
    id: 6,
    title: "Setufy",
    description: "A link-in-bio page builder that lets users create a single customizable page to share all their important links.",
    tags: ["React", "Node.js", "Express", "Supabase"],
    image: "/setufy.jpg",
    featured: false,
    personal: true
  },
  {
    id: 7,
    title: "Plinkz - URL Manager App",
    description: "Developed Android application helping users organize and search saved URLs with custom titles and intuitive search functionality. Live on Google Play Store.",
    tags: ["Android", "Java", "Firebase"],
    image: "/plinkz.jpg",
    liveLink: "https://play.google.com/store/apps/details?id=com.tushar.plinkz",
    codeLink: "https://github.com/theandroguy/plinkz",
    featured: false,
    personal: true
  }
];

export default projectsData;